import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getList = () => {
    return axios.get(`/api/roles/`, { headers: authHeader() })
        .then(res => { return res.data });
};

const getElementById = (roleId) => {
    return axios.get(`/api/roles/${roleId}`, { headers: authHeader() })
        .then(res => { return res.data });
};

const createRole = (createModel) => {
    return axios.post(`/api/roles`, createModel, { headers: authHeader() })
        .then(res => { return res.data });
};

const editRole = (editModel) => {
    return axios.patch(`/api/roles/${editModel.id}`, editModel, { headers: authHeader() })
        .then(res => { return res.data });
};

const deleteRole = (roleId) => {
    return axios.delete(`/api/roles/${roleId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

export const roleService = {
    getList,
    getElementById,
    createRole,
    editRole,
    deleteRole
};
